import React from 'react';

const PlaceHolder = () => (
  <section className="container">&nbsp;</section>
);

export default PlaceHolder;
